// extracted by mini-css-extract-plugin
module.exports = {"md":"DeliveryBlocker_md_d3YG-","ios":"DeliveryBlocker_ios_1m2aR","sheet":"DeliveryBlocker_sheet_3UiTW","handler":"DeliveryBlocker_handler_W2SCR"};